export default "__VITE_ASSET__DU6K3$Br__"